import { useClientStore } from "@/store/client";
import { useMagasinStore } from "@/store/magasin";

export const useContainerPushAbonnementLad = () => {
  const { abonnements, abonnementsExpires, isAbonneLad, aboLadMaxAtteint, isPro } = storeToRefs(useClientStore());
  const { isEligibleAbonnementLad, id: idMagasin, isNational } = storeToRefs(useMagasinStore());

  const showAboLad = computed(() => {
    return !isPro.value && (isEligibleAbonnementLad.value || isNational.value) && (!isAbonneLad.value || (isAbonneLad.value && !aboLadMaxAtteint.value && !aboLadMagasinsList.value.includes(idMagasin.value)))
  })
  const showAboLadRenouvellement = computed(() => {
    return !isPro.value && (isEligibleAbonnementLad.value || isNational.value) && (!aboLadMaxAtteint.value && !aboLadMagasinsList.value.includes(idMagasin.value) && aboLadExpiresMagasinsList.value.includes(idMagasin.value))
  })
  const aboLadMagasinsList = computed(() => {
    const magasinIdList = [];
    abonnements.value.forEach((abo) => {
      if (abo.attributes.code === 'LAD') {
        magasinIdList.push(abo.attributes.magasin_id);
      }
    });
    return magasinIdList;
  })
  const aboLadExpiresMagasinsList = computed(() => {
    const magasinIdList = [];
    abonnementsExpires.value.forEach((abo) => {
      if (abo.attributes.code === 'LAD') {
        magasinIdList.push(abo.attributes.magasin_id);
      }
    });
    return magasinIdList;
  })

  return {
    showAboLad,
    showAboLadRenouvellement
  }
}